let BASE_URL = 'https://api.boltinsight.com/'; // PROD ENVIRONMENT
let SURVEY_URL = 'https://survey.boltinsight.com';
let RECRUITMENT_URL = 'https://recruitapi.boltinsight.com/';
let ENV = 'prod';

if (process.env.REACT_APP_ENV === 'next') {
  // UAT ENVIRONMENT
  BASE_URL = 'https://api-uat.boltinsight.com/';

  ENV = 'uat';
}
if (process.env.REACT_APP_ENV === 'dev') {
  // DEV ENVIRONMENT
  BASE_URL = 'https://api-dev.boltinsight.com/';
  SURVEY_URL = 'https://survey-dev.boltinsight.com';
  RECRUITMENT_URL = ' https://recruitapi-dev.boltinsight.com/';
  ENV = 'dev';
}

if (process.env.NODE_ENV === 'development') {
  //DEV ENVIRONMENT
  if (process.env.REACT_APP_ENV === 'local') {
    RECRUITMENT_URL = 'http://localhost:3001/';
    BASE_URL = 'http://localhost:8080/';
    SURVEY_URL = 'https://survey.boltinsight.com'; //should be changed to live survey url when using live data https://survey.boltinsight.com
  } else {
    BASE_URL = 'https://api-dev.boltinsight.com/';
    SURVEY_URL = 'https://survey-dev.boltinsight.com';
  }

  ENV = 'dev';
}
export const SERVER_URL = `${BASE_URL}person-api/0.0/`;
export const ADMIN_SERVER_URL = `${BASE_URL}admin-api/0.0/`;
export const GOOGLE_ANALYTICS_MEASUREMENT_ID = 'G-RYD6CS5RXV';
export { SURVEY_URL, RECRUITMENT_URL, ENV };
